import { render } from "./EcommerceProcessor.vue?vue&type=template&id=51b2a296"
import script from "./EcommerceProcessor.vue?vue&type=script&lang=js"
export * from "./EcommerceProcessor.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/10eqs/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__